import { Component, computed, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons';
import { LpImgComponent } from '@gametailors/leerplus';
import { LpRidLocationStop } from '../../../../typings/schema';
import { fromDateString } from '../../services/rid-calendar.service';
import { RidProgressDot, RidProgressDotTone } from '../rid-progress-dot/rid-progress-dot';

/** LOCKED: can't be started yet. OPEN: can be started, but isn't yet. */
export type RidLocationStopState = 'LOCKED' | 'OPEN' | 'IN_PROGRESS' | 'FINISHED';

/** Its sizes are relative to its own width, so the parent only decides how wide it is. */
@Component({
  selector: 'rid-location-stop',
  imports: [FaIconComponent, LpImgComponent, RidProgressDot],
  templateUrl: './rid-location-stop.html',
  host: {
    class: '@container block aspect-[7/8] transition-transform duration-150',
    // only an unlocked card is a hover group, so only it lifts off the board on hover
    '[class]': "state() === 'LOCKED' ? 'grayscale' : 'group hover:-rotate-2 hover:scale-105'",
  },
})
export class RidLocationStop {
  stop = input.required<LpRidLocationStop>();
  state = input.required<RidLocationStopState>();
  /** The date (YYYY-MM-DD) the stop was done on, written on the card like in a log book. */
  date = input<string>();
  /** Whether each assignment of the stop is finished, shown as one dot per assignment: checked when finished, an outline still to fill if not. */
  assignmentsFinished = input<boolean[]>([]);
  /** A ring keeps rippling out of the card, to call the player there. */
  pulsing = input(false);

  protected readonly faLock = faLock;

  protected readonly cardClass = computed(() => {
    const classes: Record<RidLocationStopState, string> = {
      LOCKED: 'bg-white text-slate-800',
      OPEN: 'bg-white text-slate-800',
      IN_PROGRESS: 'bg-amber-300 text-slate-800',
      FINISHED: 'bg-green-600 text-white',
    };
    return classes[this.state()];
  });
  protected readonly dotTone = computed(() => {
    const tones: Record<RidLocationStopState, RidProgressDotTone> = {
      LOCKED: 'LIGHT',
      OPEN: 'LIGHT',
      IN_PROGRESS: 'AMBER',
      FINISHED: 'GREEN',
    };
    return tones[this.state()];
  });
  protected readonly formattedDate = computed(() => {
    const date = this.date();
    return date && fromDateString(date).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
  });
}
